import React from 'react';
import GeneralChartsContent from "./general-charts-content.jsx";
import DetailsContent from "./details-content.jsx";

const ReportContent = ({ data, collapsed }) => {
    return (
        <>
            <GeneralChartsContent key={`general-${collapsed}`} data={data?.supplyGraphs}/>

            <DetailsContent
                key={`vehicle-details-${collapsed}`}
                title="Abastecimentos por veículo"
                data={data?.supplyTables}
                exportVehicle={data?.export_vehicle}
                exportStation={data?.export_gas_station}
                type="vehicle"
            />

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;